import { Progress } from '@nextui-org/react';
import { useState } from 'react';

const DownloadButton = () => {
    const [progress, setProgress] = useState(0);
    const [isDownloading, setIsDownloading] = useState(false);

    const downloadFile = async () => {
        setIsDownloading(true);
        setProgress(0);

        try {
            const response = await fetch('https://api.tonaliteh.com/api/export-paintings');

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const contentLength = response.headers.get('Content-Length');

            if (!contentLength) {
                // If content length is not available, we can't show progress accurately
                const blob = await response.blob();
                triggerDownload(blob);
                return;
            }

            const totalBytes = parseInt(contentLength, 10);
            let loadedBytes = 0;
            const reader = response.body.getReader();
            const chunks = [];

            // Read the data in chunks
            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                chunks.push(value);
                loadedBytes += value.length;

                // Update progress percentage
                setProgress(Math.round((loadedBytes / totalBytes) * 100));
            }

            // Combine chunks into a Blob and trigger download
            const blob = new Blob(chunks);
            triggerDownload(blob);
        } catch (error) {
            alert(error)
        } finally {
            setIsDownloading(false);
            setProgress(0);
        }
    };

    // Helper function to trigger download
    const triggerDownload = (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'paintings.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    };

    return (
        <div className='flex flex-col pb-4 gap-8'>
            <button onClick={downloadFile} disabled={isDownloading} className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br w-fit focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
                {isDownloading ? `دانلود: ${progress}%` : 'خروجی گرفتن'}
            </button>
            {isDownloading && <Progress color='secondary' className='w-1/4' value={progress} />}
        </div>
    );
};

export default DownloadButton;
